import * as React from 'react';
import { useObservable } from 'react-use-observable';

import eduzzAccountsService from 'v2/services/eduzzAccount';

import Alert from '@eduzz/fidc-alert';

function FIDCAlert() {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  if (!user) return null;

  return <Alert className='mb-4!' eduzzId={user.id} userName={user.full_name} application='orbita' />;
}

export { FIDCAlert };
